import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTreeViewContext } from "../TreeViewContext";

/**
 * "Leave this page?" confirmation before opening Input Data / Estimation /
 * drawing leaves, which are full editable forms living on other pages.
 */
export const ConfirmNavigationDialog = () => {
  const { confirmTarget, handleConfirmOpen, handleConfirmCancel } =
    useTreeViewContext();

  const title = confirmTarget
    ? confirmTarget.kind === "drawing"
      ? "Open drawing BOM?"
      : confirmTarget.kind === "new-revision"
        ? "Start a new revision?"
        : `Open in ${confirmTarget.openLabel || confirmTarget.subTabLabel || confirmTarget.topTabLabel || "Estimation"}?`
    : "";

  const body =
    confirmTarget?.kind === "drawing" ? (
      <>
        You&apos;re about to leave this page and open drawing{" "}
        <strong>{confirmTarget.dwgNumber || "Untitled drawing"}</strong>
        {confirmTarget.revision != null && confirmTarget.revision !== ""
          ? ` (Rev (${confirmTarget.revision}))`
          : ""}{" "}
        from <strong>{confirmTarget.projectName}</strong> in the drawing BOM
        page. Continue?
      </>
    ) : confirmTarget?.kind === "new-revision" ? (
      <>
        You&apos;re about to leave this page and start a new revision
        {confirmTarget.revision
          ? ` (Rev ${confirmTarget.revision})`
          : ""} of <strong>{confirmTarget.projectName}</strong> in the{" "}
        {confirmTarget.subTabLabel || confirmTarget.topTabLabel} tab. Like the
        module&apos;s own &quot;Add New Revision&quot;, it isn&apos;t stored
        until you save it there — and any unsaved changes here won&apos;t be
        saved. Continue?
      </>
    ) : confirmTarget ? (
      <>
        You&apos;re about to leave this page and open{" "}
        <strong>{confirmTarget.projectName}</strong>
        {/* Spec has no revisions of its own to name - see SpecNode. */}
        {confirmTarget.revision != null
          ? ` — revision ${confirmTarget.revision} — `
          : " "}
        in the{" "}
        {confirmTarget.openLabel ||
          confirmTarget.subTabLabel ||
          confirmTarget.topTabLabel}{" "}
        tab. Any unsaved changes here won&apos;t be saved. Continue?
      </>
    ) : null;

  return (
    <Dialog
      open={Boolean(confirmTarget)}
      onClose={handleConfirmCancel}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ wordBreak: "break-word" }}>
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirmCancel}>Cancel</Button>
        <Button onClick={handleConfirmOpen} variant="contained" autoFocus>
          {confirmTarget?.kind === "new-revision" ? "Create" : "Open"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
